import * as IconSelector from '../icons';

export const tiposDocumento = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: 'Gasto',
        label: 'Gasto',
        description: 'Gasto',
        icon: IconSelector.GastosIcon,
        color: 'Red',
        entrada: false
    },
    {
        value: 'Compra',
        label: 'Compra',
        description: 'Compra',
        icon: IconSelector.PointIcon,
        color: 'Orange',
        entrada: false
    },
    {
        value: 'Nomina',
        label: 'Nomina',
        description: 'Nomina',
        icon: IconSelector.PointIcon,
        color: 'Blue',
        entrada: false
    },
    {
        value: 'Liquidacion',
        label: 'Liquidación',
        description: 'Liquidación',
        icon: IconSelector.LiquidacionesIcon,
        color: 'Green',
        entrada: true
    }
];
